export const interfaceHintsSelector = (state) => state.get('ui').get('interfaceHints');
